import { useStore } from 'effector-react';
import { sendEvent } from 'model/helpers/events.model';
import { lastScreen$, screenHistoryPush, ScreenName } from 'model/helpers/screens-history';
import { useLocalization } from 'model/localization.model';
import { sessionConfig$ } from 'model/session.model';
import { h } from 'preact';
import { ErrorLayout } from 'features/fallback/ui/error-layout';
import { useEffect } from 'preact/hooks';

export const Unhandled = () => {
	const t = useLocalization();
	const lastScreen = useStore(lastScreen$);
	const sessionConfig = useStore(sessionConfig$);

	useEffect(() => {
		setTimeout(() => {
			sendEvent({
				event: 'unhandled_error_screen_shown',
				event_attributes: {
					type: 'desktop',
					last_screen: lastScreen,
				},
			});
		}, 20)
		screenHistoryPush(ScreenName.error_desktop);
	}, []);

	return (
		<ErrorLayout
			title={t('flow.err.title')}
			description={t('flow.err.subtitle', {
				'flow.err.subtitle.sub': `<a href="${sessionConfig ? sessionConfig.urls.support_url : 'mailto:support@hive.id'}">${t('flow.err.subtitle.sub')}</a>`,
			})}
		/>
	);
};
